<template>
  <svg
    width="256"
    height="256"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M168.192 228.112H142.477C139.098 228.112 136.358 230.851 136.358 234.231V244.503C136.358 247.882 139.098 250.621 142.477 250.621H168.192C171.571 250.621 174.31 247.882 174.31 244.503V234.231C174.31 230.851 171.571 228.112 168.192 228.112Z"
      class="fill-secondary-500"
    />
    <path
      d="M195.827 247.799C208.898 247.799 219.494 237.202 219.494 224.131C219.494 211.06 208.898 200.464 195.827 200.464C182.756 200.464 172.16 211.06 172.16 224.131C172.16 237.202 182.756 247.799 195.827 247.799Z"
      class="fill-brand-100"
    />
    <path
      d="M110.33 201.808C115.101 201.808 118.97 197.94 118.97 193.168C118.97 188.396 115.101 184.528 110.33 184.528C105.558 184.528 101.69 188.396 101.69 193.168C101.69 197.94 105.558 201.808 110.33 201.808Z"
      class="fill-secondary-500"
    />
    <path
      d="M51.5968 228.003C59.9456 228.003 66.7136 221.235 66.7136 212.887C66.7136 204.538 59.9456 197.77 51.5968 197.77C43.248 197.77 36.48 204.538 36.48 212.887C36.48 221.235 43.248 228.003 51.5968 228.003Z"
      class="fill-brand-300"
    />
    <path
      d="M172.16 181.398C172.16 176.401 168.11 172.349 163.114 172.349C158.117 172.349 154.067 176.401 154.067 181.398V219.062C154.067 224.06 158.117 228.112 163.114 228.112C168.11 228.112 172.16 224.06 172.16 219.062V181.398Z"
      class="fill-brand-300"
    />
    <path
      d="M103.859 200.464H74.5152C70.2065 200.464 66.7136 203.957 66.7136 208.266V237.61C66.7136 241.918 70.2065 245.411 74.5152 245.411H103.859C108.168 245.411 111.661 241.918 111.661 237.61V208.266C111.661 203.957 108.168 200.464 103.859 200.464Z"
      class="fill-brand-100"
    />
    <path
      d="M172.186 161.744H217.28V85.4369C217.274 40.9057 180.838 4.72013 136.211 5.12333C91.9744 5.53293 56.6464 42.2625 56.6464 86.5057V161.744H101.741V85.4369C101.741 65.7505 117.978 49.7825 137.766 50.2241C157.018 50.6593 172.179 66.8833 172.179 86.1345V161.738L172.186 161.744Z"
      class="fill-brand-500"
    />
    <path
      d="M172.186 161.744V195.882C172.186 198.416 174.24 200.464 176.768 200.464H212.698C215.232 200.464 217.28 198.41 217.28 195.882V161.744H172.186Z"
      class="fill-secondary-500"
    />
    <path
      d="M61.2288 200.464H97.1584C99.6928 200.464 101.741 198.41 101.741 195.882V161.744H56.6464V195.882C56.6464 198.416 58.7008 200.464 61.2288 200.464Z"
      class="fill-secondary-500"
    />
  </svg>
</template>

<script>
  export default {
    name: 'ConsolidatingLoans'
  }
</script>
